export const MOCK_ALERTS = [
  { id: 'ALR-8921', severity: 'critical', type: 'Anomalous Access', asset: 'db-prod-01', time: '2 mins ago', status: 'active', description: 'Multiple failed login attempts followed by successful access from unfamiliar IP.' },
  { id: 'ALR-8920', severity: 'high', type: 'Vulnerability Detected', asset: 'web-front-04', time: '15 mins ago', status: 'active', description: 'Outdated OpenSSL version detected matching CVE-2023-XXXX.' },
  { id: 'ALR-8919', severity: 'medium', type: 'Policy Violation', asset: 'user-wkst-29', time: '1 hour ago', status: 'acknowledged', description: 'Unauthorized application installation detected (BitTorrent client).' },
  { id: 'ALR-8918', severity: 'low', type: 'Configuration Drift', asset: 'fw-edge-01', time: '3 hours ago', status: 'resolved', description: 'Non-standard port opened on external interface.' },
  { id: 'ALR-8917', severity: 'high', type: 'Malware Signature', asset: 'mail-exch-02', time: '5 hours ago', status: 'active', description: 'Suspicious attachment pattern identified in quarantine queue.' },
];

export const MOCK_ASSETS = [
  { id: 'AST-101', name: 'db-prod-01', type: 'Database', status: 'vulnerable', riskScore: 88, lastScanned: '10 mins ago' },
  { id: 'AST-102', name: 'web-front-01', type: 'Server', status: 'secure', riskScore: 12, lastScanned: '1 hour ago' },
  { id: 'AST-103', name: 'web-front-02', type: 'Server', status: 'secure', riskScore: 15, lastScanned: '1 hour ago' },
  { id: 'AST-104', name: 'user-wkst-29', type: 'Endpoint', status: 'warning', riskScore: 45, lastScanned: '2 hours ago' },
  { id: 'AST-105', name: 'fw-edge-01', type: 'Network', status: 'secure', riskScore: 5, lastScanned: '5 mins ago' },
  { id: 'AST-106', name: 'k8s-cluster-main', type: 'Container', status: 'vulnerable', riskScore: 72, lastScanned: '30 mins ago' },
];

export const MOCK_COMPLIANCE = [
  { id: 'POL-01', name: 'Data Encryption at Rest', framework: 'SOC2', status: 'passed', progress: 100 },
  { id: 'POL-02', name: 'MFA Enforced for Admin', framework: 'ISO27001', status: 'failed', progress: 85 },
  { id: 'POL-03', name: 'Quarterly Vulnerability Scans', framework: 'PCI-DSS', status: 'passed', progress: 100 },
  { id: 'POL-04', name: 'Endpoint Antivirus Active', framework: 'CIS Controls', status: 'warning', progress: 92 },
];

export const RISK_TREND_DATA = {
  dates: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  scores: [45, 42, 48, 55, 62, 58, 65]
};

export const DEMO_WORKFLOW = [
  {
    step: 1,
    title: 'Agent Deployment',
    description: 'Deploy the CyberLoom lightweight agent or connect via API to your cloud provider (AWS, Azure, GCP).',
    action: 'Connect Provider',
    status: 'success'
  },
  {
    step: 2,
    title: 'Asset Discovery',
    description: 'The system automatically crawls your network mesh to identify servers, databases, and endpoints.',
    action: 'Run Discovery',
    status: 'success'
  },
  {
    step: 3,
    title: 'Vulnerability Scan',
    description: 'Passive scanning identifies outdated packages, open ports, and misconfigured permissions.',
    action: 'Initiate Scan',
    status: 'in-progress'
  },
  {
    step: 4,
    title: 'Risk Category Mapping',
    description: 'Assets are categorized by sensitivity and threat level to create a prioritize remediation list.',
    action: 'Map Risks',
    status: 'pending'
  },
  {
    step: 5,
    title: 'Policy Compliance',
    description: 'Evaluate configuration against SOC2, ISO27001, and custom internal security checklists.',
    action: 'Audit Checklist',
    status: 'pending'
  },
  {
    step: 6,
    title: 'Alert Consolidation',
    description: 'CyberLoom groups raw logs into actionable alert lanes to prevent notification fatigue.',
    action: 'Review Lanes',
    status: 'pending'
  },
  {
    step: 7,
    title: 'Posture Reporting',
    description: 'Generate executive summaries showing risk trends and compliance gaps for stakeholders.',
    action: 'Generate PDF',
    status: 'pending'
  }
];

export const DEMO_SAMPLE_RECORDS = [
  { id: 'REC-001', name: 'AWS-S3-PUBLIC-01', category: 'Storage', risk: 'Critical', date: '2024-05-20', note: 'Bucket has public read access enabled.' },
  { id: 'REC-002', name: 'PROD-K8S-MASTER', category: 'Computing', risk: 'High', date: '2024-05-21', note: 'API server port exposed to public internet.' },
  { id: 'REC-003', name: 'DB-REPLICA-EU', category: 'Database', risk: 'Medium', date: '2024-05-19', note: 'Encryption at rest not confirmed.' },
  { id: 'REC-004', name: 'VPN-GATEWAY-WEST', category: 'Network', risk: 'Low', date: '2024-05-22', note: 'Firmware update available (minor).' },
  { id: 'REC-005', name: 'OFFICE-PRINTER-04', category: 'IoT', risk: 'Medium', date: '2024-05-18', note: 'Default admin credentials detected.' },
];